module.exports = __webpack_public_path__ + "img/bg-2_word.ce6f5846.jpg";